import { NavLink } from "react-router-dom";

export const SidebarLink = ({ path, icon, label }) => {
  return (
    <li
      key={path}
      className={`px-1 py-2 rounded-sm mb-0.5 last:mb-0 capitalize`}
    >
      <NavLink
        end
        to={`/dashboard/${path}`}
        className={`block text-slate-200 hover:text-white truncate transition duration-150`}
      >
        <div className="flex items-center">
          <span className="text-sm font-medium ml-3 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
            <span className="flex text-lg mr-4">{icon}</span>
          </span>
          <p className="text-sm">{label}</p>
        </div>
      </NavLink>
    </li>
  );
};